import { render, staticRenderFns } from "./CollectionsEdit.vue?vue&type=template&id=b656d1ac"
import script from "./CollectionsEdit.vue?vue&type=script&lang=js"
export * from "./CollectionsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports